import { Metadata } from '../types';

import { PermissionGroup, RawPermissionGroup } from './types';

export const toPermissionGroup = ({
  data, metadata,
}: {
  data: RawPermissionGroup,
  metadata: Metadata
}): {data: PermissionGroup, metadata: Metadata} => ({
  data: {
    ...data,
    id: data.groupId,
    users: data.users?.map((user) => ({
      ...user,
      id: user.value,
    })),
  },
  metadata: {
    ...metadata,
    id: {
      hide: true,
      label: 'ID',
      type: 'text',
      editable: false,
    },
  },
});
